module.exports = "/packs/media/images/outcome-investment-c9be2cb22957eff37f3714986e74e635.png";